<label class="checkbox component">
  @if (labelPosition === 'before') {
  <ng-container *ngTemplateOutlet="label"></ng-container>
  }
  <input
    type="checkbox"
    [attr.id]="id"
    [attr.name]="name"
    [disabled]="disabled"
    [checked]="checked"
    (change)="click($event)"
    [ngClass]="{
      'left-gap': labelPosition === 'before',
      'right-gap': labelPosition === 'after',
      'gray-style': inputClass === 'gray-style',
      'widget-decimal': inputClass === 'widget'
    }"
  />
  @if (labelPosition === 'after') {
  <ng-container *ngTemplateOutlet="label"></ng-container>
  }
</label>
<ng-template #label>
  @if (!isDynamicLabel) {
  <span
    [ngClass]="{ 'widget-decimal': inputClass === 'widget' }"
    translate
    [translateParams]="translateParams"
  >
    {{ labelKey }}
  </span>
  } @if (isDynamicLabel) {
  <span [ngClass]="{ 'widget-decimal': inputClass === 'widget' }">
    {{ labelKey | translate }}
  </span>
  }
</ng-template>
